<template>
<!--  <Panel :header="$t('Invoices') + (periodLabel ? ' (' + periodLabel + ')' : '')" :toggleable="false" :collapsed="isCollapsed">-->
<!--  <Panel :toggleable="false" :collapsed="isCollapsed">-->
<!--    &lt;!&ndash;    <div class="datatable-wrapper" v-if="invoices" style="min-height: 169px;">&ndash;&gt;-->
<!--    <template #header>-->
<!--      <div class="header">-->
<!--        <span><b>{{ $t('Invoices') }}</b></span>-->
<!--        <span v-if="periodLabel" class="p-text-secondary small-text p-d-flex p-jc-end">{{ periodLabel }}</span>-->
<!--      </div>-->
<!--    </template>-->
  <Panel :toggleable="false" :collapsed="isCollapsed">
    <template #header>
      <div class="statistics-panel-header">
        <b>{{ $t('Invoices') }}</b>
        <span v-if="periodLabel" class="p-text-secondary statistics-panel-date">
          {{ periodLabel }}
        </span>
      </div>
    </template>

    <div class="datatable-wrapper" v-if="invoices">
      <table class="p-datatable p-datatable-striped p-datatable-sm p-datatable-hoverable-rows positions-table">
        <thead class="p-datatable-tbody">
        <!--        <thead class="p-datatable-thead">-->
        <tr class="table-opened-info__header-row">
          <th>{{ $t('Type') }}</th>
          <th>{{ $t('Count') }}</th>
          <th>{{ $t('Sum without tax') }}</th>
          <th>{{ $t('Tax') }}</th>
          <th>{{ $t('Total') }}</th>
        </tr>
        </thead>
        <tbody class="p-datatable-tbody">
        <tr>
          <td>{{ $t('Sales invoices') }}</td>
          <td>{{ invoices.sales.count }}</td>
          <td>{{ formatCurrency(invoices.sales.sum) }}</td>
          <td>{{ formatCurrency(invoices.sales.tax) }}</td>
          <td>{{ formatCurrency(invoices.sales.total) }}</td>
        </tr>

        <tr>
          <td>{{ $t('Prepayment Invoices') }}</td>
          <td>{{ invoices.prepayment.count }}</td>
          <td>{{ formatCurrency(invoices.prepayment.sum) }}</td>
          <td>{{ formatCurrency(invoices.prepayment.tax) }}</td>
          <td>{{ formatCurrency(invoices.prepayment.total) }}</td>
        </tr>

        <tr class="table-opened-info__row--total">
          <td :class="{ 'no-bottom-border': !canUsePurchaseInvoices }">
            {{ $t('Total') }}
          </td>
          <td :class="{ 'no-bottom-border': !canUsePurchaseInvoices }">
            {{ salesInvoicesTotal.count }}
          </td>
          <td :class="{ 'no-bottom-border': !canUsePurchaseInvoices }">
            {{ formatCurrency(salesInvoicesTotal.sum) }}
          </td>
          <td :class="{ 'no-bottom-border': !canUsePurchaseInvoices }">
            {{ formatCurrency(salesInvoicesTotal.tax) }}
          </td>
          <td :class="{ 'no-bottom-border': !canUsePurchaseInvoices }">
            {{ formatCurrency(salesInvoicesTotal.total) }}
          </td>
        </tr>

        <tr v-if="canUsePurchaseInvoices">
          <td class="no-bottom-border">{{ $t('Purchase invoices') }}</td>
          <td class="no-bottom-border">{{ invoices.purchase.count }}</td>
          <td class="no-bottom-border">{{ formatCurrency(invoices.purchase.sum) }}</td>
          <td class="no-bottom-border">{{ formatCurrency(invoices.purchase.tax) }}</td>
          <td class="no-bottom-border">{{ formatCurrency(invoices.purchase.total) }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-else style="text-align: center; padding: 20px;">
      {{ $t('No data available' )}}
    </div>
  </Panel>
</template>

<script>
import formatMixins from "@/mixins/formatMixins";
import billingFeaturesMixins from '@/mixins/billingFeaturesMixins'

export default {
  mixins: [ formatMixins, billingFeaturesMixins ],
  name: 'InvoicesPanel',
  props: {
    periodLabel: { type: String, default: '' },
    invoices: {
      type: Object,
    },
  },
  data: () => {
    return {
      isCollapsed: false,
    }
  },
  computed: {
    salesInvoicesTotal() {
      const sales = this.invoices?.sales || {}
      const prepayment = this.invoices?.prepayment || {}

      return {
        count: Number(sales.count || 0) + Number(prepayment.count || 0),
        sum: Number(sales.sum || 0) + Number(prepayment.sum || 0),
        tax: Number(sales.tax || 0) + Number(prepayment.tax || 0),
        total: Number(sales.total || 0) + Number(prepayment.total || 0),
      }
    }
  }
}
</script>
<!--<style scoped lang="scss">-->
<!--</style>-->